/* <countdown-timer>: counts down to the next occurrence of a daily time (HH:MM, visitor's local time). */
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.message = this.querySelector('[data-message]');
    const match = /^\s*(\d{1,2})\s*:\s*(\d{2})/.exec(this.dataset.endTime || '');
    this.target = match ? { hours: Math.min(23, Number(match[1])), minutes: Math.min(59, Number(match[2])) } : null;
    this.tick();
    clearInterval(this.timer);
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  nextTarget(now) {
    const target = new Date(now);
    target.setHours(this.target.hours, this.target.minutes, 0, 0);
    if (target <= now) target.setDate(target.getDate() + 1);
    return target;
  }

  tick() {
    if (!this.target) {
      if (this.message) this.message.textContent = this.dataset.missing || '';
      return;
    }
    const now = new Date();
    const left = Math.max(0, this.nextTarget(now) - now);
    const pad = (n) => String(n).padStart(2, '0');
    const values = {
      days: Math.floor(left / 86400000),
      hours: Math.floor((left % 86400000) / 3600000),
      minutes: Math.floor((left % 3600000) / 60000),
      seconds: Math.floor((left % 60000) / 1000),
    };
    for (const [key, el] of Object.entries(this.units)) if (el) el.textContent = pad(values[key]);
    if (this.message) this.message.textContent = '';
  }
}

if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);
